var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLightGradient = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1126 982"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "light-gradient_svg__a",
  width: 1127,
  height: 982,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h1127v982H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#light-gradient_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#light-gradient_svg__b)",
  fillOpacity: 0.8,
  d: "M1043.57-289.574C1300-274.232 1452.13 7.713 1330.2 241.634l-280.25 537.635c-134.306 257.661-492.332 261.311-624.967 6.375L127.279 213.431C-3.093-37.156 187.991-340.764 465.623-324.153z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "light-gradient_svg__b",
  x1: 1940.78,
  x2: 345.452,
  y1: -377.717,
  y2: 512.085,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2A0E53"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467,
  stopColor: "#9233CB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.696,
  stopColor: "#BF56DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#BF56DE",
  stopOpacity: 0.65
})))));
export default SvgLightGradient;